export enum COLUMN_KEYS {
  type = 'paymentName',
  status = 'status',
  date = 'received',
  price = 'totalPrice',
  id = 'id',
}
